<template>
  <v-list
    color="transparent"
  >
    <v-list-item
      v-for="file in files"
      :key="file.path"
    >
      <v-chip
        :close="canRemove"
        color="primary lighten-3"
        label
        text-color="white"
        :href="fileLink(file)"
        target="_blank"
        small
        @click:close="fileRemove(file)"
      >
        <v-icon
          left
          v-text="fileIcon(file)"
        />
        {{ fileNameShow(file) }}
      </v-chip>
    </v-list-item>
  </v-list>
</template>

<script>


    export default {
        name: "File",

        props: {
            files: {
                type: Array,
                required: true,
            },
            fileLinkPath: {
                type: String,
                required: true
            },
            canRemove: {
                type: Boolean,
                required: false,
                default() {
                    return true
                }
            },
        },

        computed: {},

        methods: {
            fileIcon(file) {
                const Files = {
                    pdf: 'mdi-file-pdf',
                    png: 'mdi-file-image',
                    jpg: 'mdi-file-image',
                    jpeg: 'mdi-file-image',
                    gif: 'mdi-file-image',
                    tif: 'mdi-file-image',
                    webp: 'mdi-file-image',
                    txt: 'mdi-file-document-outline',
                    xls: 'mdi-file-excel',
                    xlsx: 'mdi-file-excel',
                    csv: 'mdi-file-excel',
                    doc: 'mdi-file-word',
                    docx: 'mdi-file-word',
                };

                let ext = file.name.split('.').pop();

                if (Files[ext.toLowerCase()]) {
                    return Files[ext.toLowerCase()]
                }

                return 'mdi-file-document-outline'
            },

            fileNameShow(file) {
                let fileName = file.name.split('.');
                fileName.shift();
                return fileName.join('.')
            },

            fileLink(file) {
                let path = file.path;

                if (path[0] === '/') {
                    path = path.substring(1);
                }

                return process.env.VUE_APP_SERVER_URL + `${this.fileLinkPath}/${path}`;
            },

            fileRemove(filePath) {

                if (filePath[0] === '/') {
                    filePath = filePath.substring(1);
                }

                this.loading = true;
                let self = this;

                this.$emit('fileRemove',
                    filePath,
                    () => {
                        self.loading = false;
                    }
                );

            },
        }
    }
</script>

<style scoped>

</style>
